// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.crossword-and-controls {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: auto;
  justify-content: center;
  color: white;

}
.crossword-container {
  padding: 1rem;
  background-color: black;
  color: white;
}

.controls {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.select, .input, .button {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
}

.select {
  width: 180px;
}

.input {
  width: 60px;
}

.button {
  background-color: #3b82f6;
  color: white;
  cursor: pointer;
}

.button:hover {
  background-color: #2563eb;
}

.error {
  background-color: #fee2e2;
  border: 1px solid #f87171;
  color: #b91c1c;
  padding: 0.75rem;
  border-radius: 0.25rem;
  margin-bottom: 1rem;
}

.grid {
  display: grid;
  gap: 1px;
}

.cell {
  width: 40px;
  height: 40px;
  border: 1px solid #d1d5db;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  font-weight: bold;
}

.word-list {
  margin-top: 1rem;
}

.word-list h3 {
  font-weight: bold;
}

.word-list ul {
  list-style-type: disc;
  list-style-position: inside;
}

.spinner {
  border: 16px solid #f3f3f3;
  /* Light grey */
  border-top: 16px solid #3498db;
  /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.clues-container {
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;;AAEd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".crossword-and-controls {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: auto;\n  justify-content: center;\n  color: white;\n\n}\n.crossword-container {\n  padding: 1rem;\n  background-color: black;\n  color: white;\n}\n\n.controls {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.select, .input, .button {\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 0.25rem;\n}\n\n.select {\n  width: 180px;\n}\n\n.input {\n  width: 60px;\n}\n\n.button {\n  background-color: #3b82f6;\n  color: white;\n  cursor: pointer;\n}\n\n.button:hover {\n  background-color: #2563eb;\n}\n\n.error {\n  background-color: #fee2e2;\n  border: 1px solid #f87171;\n  color: #b91c1c;\n  padding: 0.75rem;\n  border-radius: 0.25rem;\n  margin-bottom: 1rem;\n}\n\n.grid {\n  display: grid;\n  gap: 1px;\n}\n\n.cell {\n  width: 40px;\n  height: 40px;\n  border: 1px solid #d1d5db;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: white;\n  font-weight: bold;\n}\n\n.word-list {\n  margin-top: 1rem;\n}\n\n.word-list h3 {\n  font-weight: bold;\n}\n\n.word-list ul {\n  list-style-type: disc;\n  list-style-position: inside;\n}\n\n.spinner {\n  border: 16px solid #f3f3f3;\n  /* Light grey */\n  border-top: 16px solid #3498db;\n  /* Blue */\n  border-radius: 50%;\n  width: 120px;\n  height: 120px;\n  animation: spin 2s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.clues-container {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
